<template>
  <ui-dialog
    :show="isOpen"
    :closable="false"
    persistent
    scrollable
    max-width="623"
    @input="close"
  >
    <template #header>
      <h3>
        {{ $t("message.facilityCreate.dialog.createDuplicate.title") }}
      </h3>
    </template>
    <template #default>
      <p
        class="mb-0"
        v-html="
          $t('message.facilityCreate.dialog.createDuplicate.description.main')
        "
      ></p>
      <p class="sure-question">
        {{ $t("message.facilityCreate.dialog.createDuplicate.sureToContinue") }}
      </p>
    </template>
    <template #actions>
      <div class="d-flex justify-center w-100">
        <ui-button color="primary" class="mr-3" outlined @click="close">
          {{ $t("message.common.cancel") }}
        </ui-button>
        <ui-button color="primary" class="ml-3" @click="create">
          {{ $t("message.facilityCreate.dialog.createDuplicate.confirmBtn") }}
        </ui-button>
      </div>
    </template>
  </ui-dialog>
</template>

<script>
export default {
  name: "CreateDuplicateDialog",
  props: {
    isOpen: {
      type: Boolean,
      required: true
    },
    facilityData: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    close() {
      this.$emit("close");
    },

    create() {
      this.$emit("create", { isDuplicate: true });
      this.close();
    }
  }
};
</script>

<style lang="scss" scoped>
h3 {
  width: 90%;
  margin: 0 auto;
  line-height: 28px;
  text-align: center;
}

.sure-question {
  @include font-size(22px);
  width: 100%;
  color: $text;
  line-height: 28px;
  font-weight: 600;
  text-align: center;
  margin-bottom: 0;
  margin-top: $spacing * 2;
}

p {
  color: $text;
  @include font-size(16px);
  font-weight: 500;
  text-align: center;
}

.link {
  @include font-size(16px);
  margin-left: $spacing;
  font-weight: 500;
}
</style>
